import { render } from "./ImprovementTabView.vue?vue&type=template&id=61d312d5"
import script from "./ImprovementTabView.vue?vue&type=script&lang=js"
export * from "./ImprovementTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__